// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/config_central.css
// module id = 2411
// module chunks = 0